// src/components/Sidebar.jsx - Add logout functionality
import React from 'react';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import './Sidebar.css';

const Sidebar = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <nav className="sidebar">
      <div className="sidebar-header">
        <h2>Icono</h2>
        {user && (
          <div className="user-info">
            <p>Welcome, {user.username || user.mobile}</p>
          </div>
        )}
      </div>
      
      {/* ... existing menu items ... */}
      
      <div className="sidebar-footer">
        <button onClick={handleLogout} className="logout-btn">
          Logout
        </button>
        <p>copyrights @2024 feature-motion</p>
      </div>
    </nav>
  );
};

export default Sidebar;